import {isEmpty, isNil} from 'lodash'

export const safeUrlProtocols = ['http:', 'https:']

export const isSafeUrl = (url) => {
  if (isNil(url) || typeof url !== 'string' || isEmpty(url.trim())) return false
  try {
    const {protocol} = new URL(url, window.location.origin)
    return safeUrlProtocols.includes(protocol)
  } catch {
    return false
  }
}

export const openUrlInNewTab = (url) => {
  if (!isSafeUrl(url)) return false
  const link = document.createElement('a')
  link.href = url
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  link.click()
  return true
}

export const navigateToUrl = (url) => {
  if (!isSafeUrl(url)) return false
  window.location.href = url
  return true
}

export const getChangePlanUrl = () => {
  return urls.myAccount.changePlan
}

export const urls = {
  auth: {
    login: '/login',
    signUp: '/sign-up',
    signUpSuccess: '/sign-up-success',
  },
  dashboards: {
    baseUrl: '/dashboards',
  },
  contacts: {
    baseUrl: '/contacts',
    manageContactsUrl: '/contacts/manage',
    contactListsUrl: '/contacts/lists',
    contactListBuilderUrl: '/contacts/lists/build',
  },
  activities: {
    baseUrl: '/diary',
  },
  sales: {
    baseUrl: '/sales',
  },
  priceLists: {
    baseUrl: '/price-lists',
    managePriceListsUrl: '/price-lists/manage-price-lists',
  },
  quoting: {
    baseUrl: '/quoting',
    viewQuote: '/quoting/quote',
    searchQuotes: '/quoting/search-quotes',
  },
  purchasing: {
    baseUrl: '/purchasing',
    viewPurchaseOrder: '/purchasing/purchase-order',
  },
  jobBoards: {
    baseUrl: '/job-boards',
    jobBoardsListView: '/job-boards/job-board/list',
    jobBoardView: '/job-boards/job-board/view',
  },
  deliveries: {
    baseUrl: '/deliveries',
  },
  invoicing: {
    baseUrl: '/invoicing',
    salesInvoicesUrl: '/invoicing/invoices',
    purchaseInvoicesUrl: '/invoicing/purchasing',
  },
  myAccount: {
    baseUrl: '/my-account',
    accountUrl: '/my-account/account',
    detailsUrl: '/my-account/account/details',
    changePlan: '/change-plan',
    loginsUrl: '/my-account/account/users',
    integrationsUrl: '/my-account/integrations',
    settingsUrl: '/my-account/settings',
    customFieldsUrl: '/my-account/fields',
    templatesUrl: '/my-account/templates',
    teamsUrl: '/my-account/account/teams',
    misIntegrationsUrl: '/my-account/integrations/filter/mis',
    documentIntegrationsUrl: '/my-account/integrations/filter/docs',
    setupAccountingPackageUrl: '/my-account/settings/setup-accounting-package',
    manageUsersUrl: '/my-account',
    userUrl: '/my-account/users',
    rolesUrl: '/my-account/roles',
    podSettingsUrl: '/my-account/pod-settings',
    supportUrl: '/my-account/account/support',
    clarityGoUrl: 'https://clarity-software.com/clarity-go/',
    clarityPodUrl: 'https://clarity-software.com/features/proof-of-delivery-app/',
  },
  settings: {
    generalUrl: '/my-account/settings/general',
    sendFromEmailsUrl: '/my-account/settings/general#Send_From_Emails',
    pricingUrl: '/my-account/settings/price-lists#Pricing',
    priceListsUrl: '/my-account/settings/price-lists#Price_Lists',
    pricingTemplatesUrl: '/my-account/settings/price-lists#Pricing_Templates',
    pricingGroupsUrl: '/my-account/settings/price-lists#Pricing_Groups',
    jobBoardsUrl: '/my-account/settings/production',
    deliveriesUrl: '/my-account/settings/deliveries',
    deliverySettingsUrl: '/my-account/settings/deliveries#Delivery_Settings',
    deliverySchedulingSettingsUrl: '/my-account/settings/deliveries#Delivery_Scheduling_Settings',
    deliveryMethodsUrl: '/my-account/settings/deliveries#Delivery_Methods',
    deliveryEmailsUrl: '/my-account/settings/deliveries#Delivery_Email_Notifications',
    collectionEmailsUrl: '/my-account/settings/deliveries#Collection_Email_Notifications',
    setupDepartmentsAndWorkCentres: '/my-account/settings/production#Departments___Work_Centres',
    taxCodes: '/my-account/settings/general#Tax_Codes',
    xeroSettings: '/my-account/settings/invoicing#Xero_Settings',
    quotingUserFieldsUrl: '/my-account/fields/quotes',
    purchasingUserFieldsUrl: '/my-account/fields/purchase-orders',
  },
  integrations: {
    accountsIntegrations: '/my-account/integrations/filter/accounting',
    mailchimpHelp: 'https://clarity-software.com/mailchimp-integration/',
    sageHelp: 'https://clarity-software.com/integrations/sage-50-guide/',
    zohoHelp: 'https://clarity-software.com/integrations/zoho-guide/',
    zohoSetup: 'https://go.zoho.com/ueK',
    supportUrl: 'https://clarity-software.com/support/',
    termsAndConditions: 'https://clarity-software.com/go-terms-and-conditions/',
    privacyPolicy: 'https://clarity-software.com/privacy-policy/',
    xeroHelp: 'https://clarity-software.com/xero-installation-guide/',
    tutorials: 'https://my.clarity-software.com/tutorials/',
  },
}

export const getInvoiceUrl = (invoice, isPurchase) => {
  return isPurchase
      ? `${urls.invoicing.purchaseInvoicesUrl}/purchase-invoice/${invoice.id}`
      : `${urls.invoicing.salesInvoicesUrl}/${invoice.id}`
}

export const getWebsocketUrl = () => {
    return `${getWebsocketScheme()}//${location.host}/socket`
}

export const getWebsocketScheme = () => {
  return location.protocol === "https:"
      ? "wss:"
      : "ws:"
}

export const getPrintTemplateUrl = (printTemplateId, printTemplateRouteType) => {
  return `${urls.myAccount.templatesUrl}/${printTemplateRouteType}/edit/${printTemplateId}`
}

export const getPrintTemplatesUrl = (printTemplateRouteType) => {
  return `${urls.myAccount.templatesUrl}/${printTemplateRouteType}`
}
